/**
 * Requirements handed to the wizard from chat must be the user's own text, character
 * for character. The model may only *select* an excerpt of a user message — this check
 * is the enforcement point, run on the server before an action is returned and again
 * on the client before it is executed.
 *
 * Only line endings are normalized (CRLF/CR → LF) and the excerpt is trimmed at its
 * ends; nothing inside the excerpt is normalized, so a single edited character fails.
 */
function normalizeLineEndings(text: string): string {
  return text.replace(/\r\n?/g, '\n')
}

export function isVerbatimExcerpt(candidate: string | undefined, source: string): boolean {
  if (!candidate) return false
  const excerpt = normalizeLineEndings(candidate).trim()
  if (!excerpt) return false
  return normalizeLineEndings(source).includes(excerpt)
}

/** The excerpt exactly as it appears in the source (trimmed at the ends only). */
export function extractVerbatimExcerpt(candidate: string): string {
  return normalizeLineEndings(candidate).trim()
}
